import { render, staticRenderFns } from "./YearModal.vue?vue&type=template&id=193e74c3&scoped=true&"
import script from "./YearModal.vue?vue&type=script&lang=js&"
export * from "./YearModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193e74c3",
  null
  
)

export default component.exports